export default '/build/fce0eab2.svg'